import React from "react";
import { Row, Col, Alert } from "react-bootstrap";
import { FiInfo } from "react-icons/fi";

const CastingDirectorSection = ({
  castingDirectors,
  castingDirectorId,
  setCastingDirectorId,
  bankInfo,
  todayDateStr,
}) => {
  return (
    <div className="bma-card">
      <div className="bma-card-body">
        <h2 className="bma-card-title mb-3">1. Select Casting Director</h2>
        <Row className="g-3 mb-3">
          <Col md={4}>
            <label className="bma-label">
              Casting Director <span className="req">*</span>
            </label>
            <select
              className="bma-select"
              value={castingDirectorId}
              onChange={(e) => setCastingDirectorId(e.target.value)}
              required
            >
              {castingDirectors.length > 0 ? (
                castingDirectors.map((cd) => (
                  <option key={cd.id} value={cd.id}>
                    {cd.name} (ID: #{cd.id})
                  </option>
                ))
              ) : (
                <option value="">No Casting Directors Available</option>
              )}
            </select>
          </Col>
          <Col md={4}>
            <label className="bma-label">Settlement Frequency</label>
            <input
              type="text"
              className="bma-input"
              value={bankInfo?.settlement_frequency || bankInfo?.frequency || "Per Project"}
              disabled
            />
          </Col>
          <Col md={4}>
            <label className="bma-label">Settlement Date</label>
            <input type="text" className="bma-input" value={`📅 ${todayDateStr}`} disabled />
          </Col>
        </Row>
        <Alert
          variant="info"
          className="mb-0 small d-flex align-items-center gap-2"
          style={{ background: "#1e3a8a", borderColor: "#1d4ed8", color: "#93c5fd" }}
        >
          <FiInfo />
          <span>
            Only eligible unsettled transactions for the selected casting director are shown below.
          </span>
        </Alert>
      </div>
    </div>
  );
};

export default CastingDirectorSection;